import { render, staticRenderFns } from "./AddOrUpdateDisinfect.vue?vue&type=template&id=daf70c1e&scoped=true&"
import script from "./AddOrUpdateDisinfect.vue?vue&type=script&lang=ts&"
export * from "./AddOrUpdateDisinfect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf70c1e",
  null
  
)

export default component.exports